<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ctp" id="p0028-01-0"><a id="page22"></a><a href="#/contents#fn_21" id="sn_21">DAY 21</a></p>
<p class="ct"><a href="#/contents#fn_21">COULD YOU PLEASE BE MORE SPECIFIC?</a></p>
<p class="ext"><span><i>The L<span class="small">ORD</span> had said to Abram, “Go from your country, your people and your father’s household to the land I will show you.” </i></span></p>
<p class="ext1"><i>So Abram went.</i></p>
<p class="txr"><span><span class="small">GENESIS</span> 12:1–5</span></p>
<p class="tx1" id="p0028-04-4"><span class="dcap">O</span>ne cup of flour, 3.9 quarts of oil every 7,500 miles, 20 minutes of exercise a day. We like specific instructions in our daily life. </p>
<p class="tx">We also have some experience planning trips. We’ll arrive at point A by a certain time, travel 250 miles the next day, get to point B, and then start driving again at 6:30 a.m.</p>
<p class="tx">Maybe we need the details because we are finite human beings. Maybe we like those specifics because of the illusion of control they give us. Clearly, our infinite God plans trips a little differently.</p>
<p class="tx">“Go from your country . . .” The <i>from</i> is implied in the <i>go</i>, so that instruction is not terribly helpful. “To . . .”—okay, this is what we need. I’ll program it into the GPS—“the land I will show you.” My GPS doesn’t like that destination! <i>I</i> don’t like that destination!</p>
<p class="tx">What a picture—what a definition—of faith. “Go where I will show you,” God essentially instructs. Notice the implicit promise: his showing you will mean his presence with you. And he wants to go with you because he loves you.</p>
<p class="tx2"><i>GO!</i> IS NOT AS DAUNTING WHEN YOU’RE JOURNEYING WITH GOD.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter24.vue?0f05fc50